import ApiService from '@/services/ApiService'
import Show from '@/models/Show'
import ListRequest from '@/models/requests/ListRequest'
import PaginationModel from '@/models/PaginationModel'
import type ShowStats from '@/models/ShowStats'
import type { EpisodeStats, StatsPeriod } from '@/models/ShowStats'

export default class ShowService {
  public static async create(postData: {
    name: string,
    accept_rights: boolean,
    accept_terms: boolean,
    rss_url?: string,
    image_url?: string,
  }): Promise<Show> {
    return ApiService.post<Show>(`shows`, postData)
  }

  public static async get(id: string): Promise<Show> {
    return ApiService.get<Show>(`shows/${id}`)
  }

  public static async list(queryParams: ListRequest): Promise<PaginationModel<Show>> {
    return ApiService.get<PaginationModel<Show>>(`shows`, queryParams)
  }

  public static async stats(id: string, period: StatsPeriod): Promise<ShowStats> {
    return ApiService.get<ShowStats>(`shows/${id}/stats`, { period })
  }

  public static async episodeStats(id: string, trackId: string, period: StatsPeriod): Promise<EpisodeStats> {
    return ApiService.get<EpisodeStats>(`shows/${id}/episodes/${trackId}/stats`, { period })
  }

  public static async update(show: Partial<Show>): Promise<Show> {
    return ApiService.put<Show>(`shows/${show.id}`, show)
  }
}
